import React, { Component } from 'react'
import { t } from '@billes/translator-client'

const styles = {
  labelOuter(focus) {
    return {
      float: focus ? 'right' : 'left',
      display: 'block',
      backgroundColor: '#fff',
      marginLeft: 3,
      marginRight: 0
    }
  },
  labelContainer(disabled) {
    return {
      position: 'relative',
      color: '#fff',
      backgroundColor: disabled ? 'rgb(168, 168, 168)' : '#337ab7',
      paddingLeft: 7,
      paddingRight: 7,
      paddingTop: 3,
      paddingBottom: 3,
      fontSize: 12,
      borderRadius: 2
    }
  }
}

class SelectedOptions extends Component {
  renderOption(label) {
    const { containerFocus, field, disabled } = this.props
    if (label && label.length > 48) {
      label = label.substr(0, 47) + '...'
    }
    return (
      <div style={styles.labelOuter(containerFocus && !field.actionEnter)}>
        <div style={styles.labelContainer(disabled)}>{label}</div>
      </div>
    )
  }

  render() {
    const { field, device } = this.props
    if (!field.options) {
      return null
    }
    if (!field.value || !field.value.length > 0) {
      return null
    }
    let more = null
    if (field.value.length > 1) {
      more = this.renderOption(
        t('bus-client.selectMore', { length: field.value.length - 1 })
      )
    }
    let label = field.value[field.value.length - 1]
    let { value, i18nKey, i18nPath } = label
    if (i18nKey || i18nPath) {
      let path = i18nPath || `bus-shared.aggregation.data.key.${i18nKey}`
      value = t(path)
      // the value is not found and we should fall back to value
      if (value.startsWith(path)) {
        value = label.value
      }
    }

    return (
      <div
        style={{
          height: 37,
          paddingBottom: device === 'mobile' ? 3 : 0,
          display: 'block',
          position: 'absolute',
          width: '100%',
          bottom: device === 'mobile' ? -10 : -5
        }}>
        {this.renderOption(value)}
        {more}
      </div>
    )
  }
}

export default SelectedOptions



// WEBPACK FOOTER //
// ./src/components/inputs/selectedOptions.js